import type { AdminScope } from "@/contexts/AuthContext";

type BackdateUser = {
	role?: string;
	adminScope?: AdminScope;
	groupId?: string;
	hospitals?: { id: string; name: string }[];
} | null;

/** Chain / super admin may book OPD and bill for past dates. */
export function canBackdateOpd(
	user: BackdateUser,
	isChainAdmin = false
): boolean {
	if (!user) return false;
	if (user.role === "SUPER_ADMIN") return true;
	if (isChainAdmin) return true;
	if (user.role === "HOSPITAL_ADMIN" && user.adminScope === "CHAIN") return true;
	// Stale sessions: chain admins get multiple hospitals at login; sub-admins get one.
	if (
		user.role === "HOSPITAL_ADMIN" &&
		user.groupId &&
		(user.hospitals?.length ?? 0) > 1
	) {
		return true;
	}
	return false;
}
